import Vue from 'vue'
import selectCompany from './selectCompanyDialog.vue'

let selectCompanyConstructor = Vue.extend(selectCompany)
let instance

const selectTip = function(options = {}) {
  instance = new selectCompanyConstructor({
    data: options
  })
  document.body.appendChild(instance.$mount().$el)
}

// export default importTip
export default {
  install (Vue, options) {
    Vue.prototype.$selectCompany = selectTip
  }
}


// WEBPACK FOOTER //
// ./src/components/selectCompany/selectCompany.js